import styled from 'styled-components';
import theme from '../../theme';

type PostitionProps = {
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
};

export const CargoOperationMenu = styled.button`
    position: absolute;
    background: ${theme.colors.background.white};
    z-index: 1;
    width: 2.5em;
    height: 3em;
    @media only screen and (max-width: 1920px) {
        font-size: 0.6rem;
    }
    box-shadow: -4px -2px 12px -2px ${theme.colors.border.boxShadow};
    border-radius: 4px 0 0 0;
    text-align: left;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.border.transparent};
`;

export const CargoOperationInfoMenu = styled(CargoOperationMenu)`
    background: ${({ theme }) => theme.colors.background.transparent};
    border: 0;
    box-shadow: none;
    width: auto;
    height: auto;
    padding: 3px 5px;
    position: relative;
    border: 1px solid ${({ theme }) => theme.colors.border.transparent};
`;

export const BurgerInfoMenu = styled.button<PostitionProps>`
    height: 30px;
    padding: 5px;
    text-align: center;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.border.transparent};
    margin: 0;
    background: ${({ theme }) => theme.colors.background.transparent};
    position: relative;
`;

type CargoNumberStyleProps = {
    color: string;
    withPadding?: boolean;
    bold?: boolean;
};

export const CargoNumberStyle = styled.span<CargoNumberStyleProps>`
    ${(props) => (props.color ? `background: #${props.color};` : `background: transparent;`)}
    width: fit-content;
    border-radius: 10px;
    padding: 1px 4px;
    ${(props) => props.withPadding && 'padding: 2px 8px;line-height: 1rem; font-size: 0.9rem;'}
    ${(props) => props.bold && 'font-weight: bold;'}
    font-weight: 600;
    white-space: nowrap;
`;
